//TODO: Remove this legacy director after APR 1, 2020
import React from "react";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import legacyBibles from "./legacyBibles.json";
import legacyBooks from "./legacyBooks.json";

const DEFAULT_BIBLE = "61fd76eafa1577c2-01";

const LegacyChapterRedirector = props => {
  const { legacyBible, legacyBook, chapterNumber } = props.match.params;
  let newBible, newBook;

  if (legacyBible && legacyBook) {
    newBible = legacyBibles[legacyBible] || DEFAULT_BIBLE;
    newBook = legacyBooks[legacyBook.toLowerCase()];
  }

  if (newBible && newBook) {
    const newRoute = `/bible/${newBible}/${newBook}.${chapterNumber}`;
    return <Redirect to={newRoute} />;
  }
  return null;
};

export default withRouter(LegacyChapterRedirector);
